var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('globalHeader'),_c('div',{staticClass:"page__wrap"},[_c('router-view',{staticStyle:{"max-width":"1920px","min-width":"1400px","overflow":"hidden","margin":"0 auto"}})],1),_c('globalFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }